const getStyles = () => {
 return {
    modal: {
        width: '96vw',
        height: '92vh',
        maxWidth: 'none',
        maxHeight: 'none',
        padding: '0',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
    },
    title: {
        container: {
            flex: '0 0 auto',
            padding: '10px 16px',
        },
    },
    titleRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        minWidth: 0,
    },
    titleActions: {
        display: 'flex',
        gap: '8px',
        marginRight: '12px',
        flexShrink: 0,
    },
    titleText: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize: '16px',
        fontWeight: 600,
    },
    status: {
        marginLeft: '16px',
        fontSize: '13px',
        whiteSpace: 'nowrap',
    },
    errorStatus: {
        color: '#c0392b',
    },
    successStatus: {
        color: '#2e7d32',
    },
    content: {
        content: {
            display: 'flex',
            flex: '1 1 auto',
            minHeight: 0,
            padding: 0,
            overflow: 'hidden',
            position: 'relative',
        },
    },
    viewer: {
        width: '100%',
        height: '100%',
    },
    image: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        backgroundColor: '#f5f5f5',
    },
    mediaContainer: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#111',
        padding: '16px',
    },
    video: {
        maxWidth: '100%',
        maxHeight: 'calc(100% - 48px)',
        borderRadius: '8px',
        backgroundColor: '#000',
    },
    audio: {
        width: '100%',
        maxWidth: '600px',
    },
    message: {
        margin: 'auto',
        padding: '24px',
        textAlign: 'center',
    },
    loaderOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.85)',
        zIndex: 10,
    },
    spinner: {
        width: '48px',
        height: '48px',
        border: '5px solid #e0e0e0',
        borderTop: '5px solid #337ab7',
        borderRadius: '50%',
        animation: 'docviewer-spin 0.8s linear infinite',
    },
};
};

export default getStyles;
